import { gql } from "@apollo/client";

export const contentTypes = ["news", "page"];

export function getTitle({ intl, type }) {
  return type === "news"
    ? intl.formatMessage({
        defaultMessage: "Experiences",
      })
    : intl.formatMessage({
        defaultMessage: "Education",
      });
}

export function categoriesConfig({ intl }) {
  return [
    {
      value: "hair-color",
      label: intl.formatMessage({
        defaultMessage: "Hair Color",
      }),
    },
    {
      value: "styling-care",
      label: intl.formatMessage({
        defaultMessage: "Styling & Care",
      }),
    },
    {
      value: "barbering",
      label: intl.formatMessage({
        defaultMessage: "Barbering",
      }),
    },
    {
      value: "news",
      label: intl.formatMessage({
        defaultMessage: "News",
      }),
    },
    {
      value: "celebrity",
      label: intl.formatMessage({
        defaultMessage: "Celebrity",
      }),
    },
    {
      value: "trending",
      label: intl.formatMessage({
        defaultMessage: "Trending",
      }),
    },
    {
      value: "business",
      label: intl.formatMessage({
        defaultMessage: "Business",
      }),
    },
  ];
}

export const sortConfig = [
  { label: "Sort Name Asc", value: "name-asc", key: "n", dir: "1" },
  {
    label: "Sort Latest Items",
    value: "lastest-desc",
    key: "dc",
    dir: "-1",
  },
];

export const GET_CONTENT_ITEM = gql`
  query GetContentItem($slug: String!, $locale: String) {
    content {
      findBySlug(slug: $slug, locale: $locale) {
        ... on News {
          _id
          n
          desc
          sl
          dc
          dm
          brand {
            _id
            n
          }
          gallery {
            media {
              _id
            }
          }
          galleryMobile {
            media {
              _id
            }
          }
          data {
            youtubeUrl
            isFeatured
          }
        }
        ... on Page {
          _id
          n
          desc
          sl
          dc
          dm
          gallery {
            media {
              _id
            }
          }
          galleryMobile {
            media {
              _id
            }
          }
        }
      }
    }
  }
`;

export const GET_CONTENT = gql`
  query GetNewsContent(
    $sort: [SortInput]
    $page: Int
    $filters: String
    $limit: Int
    $locale: String
  ) {
    content {
      findClubH(
        sort: $sort
        page: $page
        filters: $filters
        limit: $limit
        locale: $locale
      ) {
        docs {
          ... on News {
            _id
            n
            desc
            sl
            dc
            dm
            type
            brand {
              _id
              n
            }
            gallery {
              media {
                _id
              }
            }
            data {
              youtubeUrl
              isFeatured
            }
          }
        }
        page
        pages
        limit
        total
      }
    }
  }
`;

export const contentTagsPath = "data.content.findRewardTags";

export const contentDataPath = "content.findClubH";

export const GET_CONTENT_TAGS = gql`
  query GetContentTags($startsWith: String) {
    content {
      findRewardTags(startsWith: $startsWith)
    }
  }
`;
